import { createSelector } from '@reduxjs/toolkit';

import { getAnalyticsSearchOutput } from 'entities/analytics';
import { offersSelector } from 'entities/offers';
import {
  hasAllRefusedMplOffers,
  hasApprovedMplOffers,
  hasMplOffers,
  hasMplPreApprovalOffers,
  selectHasLeadgenGroup,
} from 'entities/scenario';

import { getUniqueOnlineGroupOrganizations } from '../lib/getUniqueOnlineGroupOrganizations';

const selectMplApplicationOrganizations = createSelector(offersSelector, getUniqueOnlineGroupOrganizations);

export const selectMplApplicationData = createSelector(selectMplApplicationOrganizations, (organizations) => ({
  organizations,
  count: organizations.length,
  logos: organizations.map((organization) => organization.logo),
}));

export const selectAnalyticsSearchOutput = createSelector(
  hasMplPreApprovalOffers,
  selectHasLeadgenGroup,
  hasMplOffers,
  hasApprovedMplOffers,
  hasAllRefusedMplOffers,
  (hasMplPreApproval, hasLeadGen, isAvailableMpl, hasApprovedMpl, isAllRefusedMpl) =>
    getAnalyticsSearchOutput({ hasMplPreApproval, hasLeadGen, isAvailableMpl, hasApprovedMpl, isAllRefusedMpl }),
);
